export default __webpack_public_path__ + "static/media/icon-play.9278d0c9.svg";